// extracted by mini-css-extract-plugin
export default {"container":"reset-password-container","success":"reset-password-success","error":"reset-password-error"};